module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.8b54921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_hero_768.png
// module id = yLxW
// module chunks = 0